import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    borderItem: {
      borderRadius: 4,
      border: "1px solid #CCD2D9",
      padding: 6,
      fontSize: 14,
      "& p": {
        marginTop: 0,
        marginBottom: 5,
      },
    },
    marginTop: {
      marginTop: 15,
    },
    name: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: 16,
      fontWeight: "bold",
    },
    topLeft: {
      flex: 1,
      minWidth: 0,
    },

    lastValidate: {
      fontSize: 13,
      marginRight: 10,
      marginLeft: 10,
    },
    w30: {
      width: "30% !important",
      display: "inline-block",
    },
    w70: {
      width: "70% !important",
      display: "inline-block",
    },
    textApproved: {
      border: "1px solid green",
      borderRadius: 4,
      padding: 10,
      color: "green",
      textAlign: "center",
    },
    textNotApproved: {
      border: "1px solid red",
      borderRadius: 4,
      padding: 10,
      color: "red",
      textAlign: "center",
    },
    bgRed: {
      backgroundColor: "#E55A5A !important",
    },
    draftSection: {
      backgroundColor: "#FFF9E6",
      border: "1px solid #FFD700",
    },
    draftHeader: {
      color: "#856404",
      borderBottom: "1px solid #FFD700",
      paddingBottom: 4,
    },
    draftDataContent: {
      marginTop: 8,
    },
    draftDataTitle: {
      fontSize: 14,
      fontWeight: "bold",
      marginBottom: 10,
      color: "#856404",
    },
  })
);

export default useStyles;
